"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Stack = _interopRequireDefault(require("../Stack"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Avatar(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.picture_url ? /*#__PURE__*/_react.default.createElement(_reactNative.Image, {
    style: {
      width: props.size,
      height: props.size
    },
    source: {
      uri: props.picture_url
    }
  }) : /*#__PURE__*/_react.default.createElement(_Box.default, {
    bg: "secondary.main",
    br: "l",
    style: {
      width: props.size,
      height: props.size
    }
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    distribution: "center",
    alignment: "center",
    direction: "vertical",
    style: {
      flex: "auto"
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    fs: "s",
    color: "common.white"
  }, props.name?.charAt(0).toUpperCase() ?? "-"))));
}

var _default = Avatar;
exports.default = _default;